import { render, staticRenderFns } from "./ProgramAreas.vue?vue&type=template&id=6da4b3d3&scoped=true&"
import script from "./ProgramAreas.vue?vue&type=script&lang=js&"
export * from "./ProgramAreas.vue?vue&type=script&lang=js&"
import style0 from "./ProgramAreas.vue?vue&type=style&index=0&id=6da4b3d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da4b3d3",
  null
  
)

export default component.exports